<template>
  <div class="wrapper">
    <!-- Modal Component -->
    <b-modal
      id="myModal"
      v-model="formModal.status"
      @cancel="resetDetailForm"
      @ok="submit"
      @show="$v.$reset()"
      @shown="
        getCompanyFacilities(company);
        getPalletTypes();
        $refs.gross_input.$el.focus();
      "
      scrollable
      :ok-disabled="loading"
      :cancel-disabled="loading"
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
      cancel-title="Cancelar"
      header-bg-variant="secondary"
      size="md"
      ref="modalContenido"
    >
      <template slot="modal-title">
        <div>
          <h3 class="mb-0">
            {{ calculateGross }}
            <small class="text-muted">Kg totales</small>
          </h3>
          <p
            v-text="connected ? '*Captura de peso automatico' : '**Digite el peso mostrado en la pantalla de la pesa'"
            :class="connected ? 'small text-success' : 'small'"
          ></p>
          <h3 class="mb-0">
            {{ calculateNet }}
            <small class="text-muted">Kg netos</small>
          </h3>
        </div>
      </template>
      <b-row>
        <b-col>
          <b-form-group
            v-if="(contentData.interplanta === false) & !connected"
            description="Los kilos que indica la pesa/romana."
            label="Kilos brutos"
            label-for="basicNumber"
          >
            <b-input-group>
              <b-form-input
                id="gross_kilograms"
                ref="gross_input"
                type="text"
                :state="$v.contentData.gross_kilograms.$dirty ? !$v.contentData.gross_kilograms.$error : null"
                v-model="$v.contentData.gross_kilograms.$model"
                :disabled="contentData.interplanta === true || loading"
                placeholder="Ingrese kilos"
              >
              </b-form-input>
              <b-input-group-append>
                <b-input-group-text>Kg</b-input-group-text>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>

          <b-form-group label="Peso del pallet">
            <b-form-radio-group
              v-model="selectedTypeWeightPallet"
              :options="optionWeightPallet"
              value-field="item"
              text-field="name"
              class="mb-1"
              disabled-field="notEnabled"
            ></b-form-radio-group>
            <b-form-select
              id="containerSelect"
              v-if="selectedTypeWeightPallet == 1"
              :disabled="loading"
              :state="$v.contentData.pallet_type.$dirty ? !$v.contentData.pallet_type.$error : null"
              v-model="$v.contentData.pallet_type.$model"
              :options="pallet_types"
              value="Seleccione..."
            ></b-form-select>
            <b-form-input
              v-if="selectedTypeWeightPallet == 2"
              type="text"
              :disabled="loading"
              placeholder=""
              v-model="$v.contentData.manual_weight.$model"
              style="text-transform: uppercase"
              :state="$v.contentData.manual_weight.$dirty ? !$v.contentData.manual_weight.$error : null"
              v-on:keyup="inputSoloNumeroDecimal"
            >
            </b-form-input>
          </b-form-group>

          <b-form-group :label="contentData.interplanta ? 'Formato' : 'Recipiente'" label-for="containerSelect">
            <search-select
              v-model="contentData.container"
              :validation="$v.contentData.container"
              :url="urlSearchContainer"
              @blur="handleBlur"
              ref="container_select"
            />

            <!-- <b-form-select
              id="containerSelect"
              @change="getBulkSpecs(contentData.container.id)"
              :state="
                $v.contentData.container.$dirty
                  ? !$v.contentData.container.$error
                  : null
              "
              v-model="$v.contentData.container.$model"
              :options="productSet.containers"
              value="Seleccione..."
            ></b-form-select> -->
          </b-form-group>

          <b-form-group
            id="example-input-group-1"
            aria-describedby="input-1-live-feedback"
            label="Cantidad"
            description="Por favor, cuente la Formato/Recipiente antes de registrar."
            label-for="basicNumber"
          >
            <b-input-group>
              <b-form-input
                type="text"
                placeholder="Ingrese unidades resultantes"
                :state="$v.contentData.quantity.$dirty ? !$v.contentData.quantity.$error : null"
                :disabled="loading"
                v-model="$v.contentData.quantity.$model"
              >
              </b-form-input>

              <b-input-group-append>
                <b-input-group-text>Un</b-input-group-text>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
          <b-form-group v-if="contentData.interplanta === true" label="Planta de proceso (CSP)" label-for="plantSelect">
            <v-2-select
              ref="plantSelect"
              :disabled="disabledFields.plant || loading"
              v-model="$v.contentData.plant.$model"
              :state="$v.contentData.plant.$dirty ? !$v.contentData.plant.$error : null"
              :options="companyFacilities.plants"
              :_reduce="(e) => e.value"
              @input="(e) => {}"
              label="text"
            />
          </b-form-group>

          <b-form-group v-if="contentData.interplanta">
            <label for="creation_date">Fecha de embalaje</label>
            <b-form-input
              type="date"
              id="creation_date"
              v-model="$v.contentData.creation_date.$model"
              :state="$v.contentData.creation_date.$dirty ? !$v.contentData.creation_date.$error : null"
            ></b-form-input>
          </b-form-group>
          <hr />
          <h4>Otras opciones</h4>

          <b-form-group
            id="example-input-group-1"
            aria-describedby="input-1-live-feedback"
            label="Número de Pallet (Opcional)"
            description="Ingrese numero de pallet. Deje en blanco si desea un numero automático."
            label-for="basicNumber"
          >
            <b-input-group>
              <b-form-input
                type="text"
                placeholder="123456789"
                :disabled="loading"
                :state="$v.contentData.pallet_number.$dirty ? !$v.contentData.pallet_number.$error : null"
                v-model="$v.contentData.pallet_number.$model"
              >
              </b-form-input>

              <b-input-group-append>
                <b-input-group-text>#</b-input-group-text>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>

          <b-form-group v-if="contentData.interplanta" label="Tipo de embarque">
            <b-form-select id="shipment_type" v-model="contentData.shipment_type" :options="shipment_type_options">
            </b-form-select>
          </b-form-group>

          <b-form-group v-if="existing_pallet === true" label="Pallet" label-for="palletSelect">
            <b-form-select
              id="palletSelect"
              v-model="contentData.pallet"
              :options="pallets"
              value="Seleccione..."
              :disabled="loading"
            ></b-form-select>
          </b-form-group>

          <div v-if="contentData.interplanta === true">
            <b-form-group
              v-for="(type, index) in productSet.spec_type"
              v-bind:label="type.name"
              :key="index"
              :disabled="loading"
              label-for="basicSelect"
            >
              <b-form-select id="specSelect" v-model="contentData.specifications[index]" :disabled="loading">
                <option v-for="spec in type.specs" :key="spec.value" v-bind:value="spec.value">
                  {{ spec.text }}
                </option>
              </b-form-select>
            </b-form-group>
          </div>

          <div v-if="productSet.spec_type_bulk.length > 0 && contentData.interplanta === false">
            <b-form-group
              v-for="(type, index) in productSet.spec_type_bulk"
              v-bind:label="type.name + ' (Opcional)'"
              :key="index"
              label-for="basicSelect"
            >
              <b-form-select id="specSelect" v-model="contentData.specifications[index]" :disabled="loading">
                <option v-for="spec in type.specs" :key="spec.value" v-bind:value="spec.value">
                  {{ spec.text }}
                </option>
              </b-form-select>
            </b-form-group>
          </div>

          <b-form-group label="Clasificación" description="">
            <b-input-group>
              <b-form-input
                type="text"
                placeholder=""
                :disabled="loading"
                v-model="contentData.classification"
                style="text-transform: uppercase"
              >
              </b-form-input>
            </b-input-group>
          </b-form-group>

          <custom-fields
            v-if="!contentData.product_type.exportable && formModal"
            :form="contentData.bulk_custom_fields"
            :input_group="productSet.bulk_custom_fields"
          ></custom-fields>

          <custom-fields
            v-if="contentData.product_type.exportable && formModal"
            :form="contentData.export_custom_fields"
            :input_group="productSet.export_custom_fields"
          ></custom-fields>
          <custom-fields
            v-if="formModal"
            :form="contentData.custom_fields"
            :input_group="content_custom_fields"
          ></custom-fields>
        </b-col>
      </b-row>
      <template v-slot:modal-ok>
        <b-spinner v-if="loading" class="mx-2" small></b-spinner><span v-if="!loading">Agregar pallet</span></template
      >
    </b-modal>
  </div>
</template>

<script>
import { decimal, integer, minValue, required, requiredIf } from "vuelidate/lib/validators";
import { bus } from "../../main";
import VueNotifications from "vue-notifications";
import miniToastr from "mini-toastr";
import Vue from "vue";
import { mapState, mapActions, mapGetters } from "vuex";
import searchSelect from "../reusable/searchSelect";
import CustomFields from "./CustomFields";
import V2Select from "../reusable/V2Select.vue";

const toastTypes = {
  success: "success",
  error: "error",
  info: "info",
  warn: "warn"
};

miniToastr.init({ types: toastTypes });

Vue.use(VueNotifications);
Vue.use(miniToastr);

export default {
  name: "ModalContenido",
  components: { searchSelect, CustomFields, V2Select },
  // This props are receiving the data from the parent component
  props: ["company", "client_customer", "waybillID", "formModal", "waybillDATE"],
  data() {
    return {
      loading: false,
      modalTitle: "Agregar detalles",
      editing_modal: false,
      contentData: {
        id: null,
        pallet_number: "",
        pallet_type: null,
        lot: "",
        interplanta: false,
        product: "",
        variety: "",
        condition: "",
        origin: "",
        shipment_type: null,
        product_type: {
          exportable: null
        },
        plant: "",
        pallet: "",
        process_date: "",
        creation_date: null,
        container: "",
        specifications: [],
        quantity: null,
        gross_kilograms: "0.00",
        net_kilograms: null,
        origin_kilograms: "",
        other: [],
        classification: "",
        manual_weight: "0",
        custom_fields: {},
        export_custom_fields: {},
        bulk_custom_fields: {}
      },
      productSet: {
        product_types: [],
        containers: [],
        varieties: [],
        spec_type: [],
        export_custom_fields: [],
        bulk_custom_fields: [],
        spec_type_bulk: []
      },
      pallet_types: [
        { value: 17, text: "Taco" },
        { value: 18, text: "Yugo" }
      ],
      shipment_type_options: [
        { value: null, text: "--------" },
        { value: 1, text: "Marítimo" },
        { value: 2, text: "Aéreo" }
      ],
      companyFacilities: [],
      existing_pallet: false,
      pallets: [],
      products: [],
      conditions: [
        { value: "Orgánico", text: "Orgánico" },
        { value: "Convencional", text: "Convencional" },
        { value: "Org. (System)", text: "Org. (System)" },
        { value: "Conv. (System)", text: "Conv. (System)" }
      ],
      disabledFields: {
        product: false,
        variety: false,
        condition: false,
        origin: false,
        plant: false
      },
      selectedTypeWeightPallet: "1",
      optionWeightPallet: [
        { item: "1", name: "Seleccionar Peso Pre-Configurado" },
        { item: "2", name: "Digitar peso manualmente" }
      ]
    };
  },
  validations: {
    contentData: {
      product: { required },
      variety: { required },
      origin: { required },
      plant: {
        required: requiredIf(function () {
          return this.contentData.interplanta;
        })
      },
      creation_date: {
        required: requiredIf(function () {
          return this.contentData.interplanta;
        })
      },
      condition: { required },
      product_type: { required },
      pallet_type: {
        required: requiredIf(function () {
          if (this.selectedTypeWeightPallet == 1) {
            return true;
          } else {
            return false;
          }
        })
      },
      container: { required },
      pallet_number: {},
      origin_kilograms: { decimal },
      quantity: {
        required,
        integer,
        minValue: minValue(1)
      },
      // net_kilograms: {
      //   required,
      //   decimal,
      //   minValue : minValue(0)
      // },
      manual_weight: {
        required: requiredIf(function () {
          if (this.selectedTypeWeightPallet == 2) {
            return true;
          } else {
            return false;
          }
        }),
        decimal
        // minValue : minValue(0.01)
      },
      gross_kilograms: {
        required: requiredIf(function () {
          return this.connected;
        }),
        decimal
        // minValue : minValue(0.01)
      }
    }
  },
  computed: {
    ...mapGetters("socketModule", ["selectedScale"]),
    ...mapState("socketModule", ["socketWeight", "connected"]),
    ...mapState({
      content_custom_fields: (state) => state.user.content_custom_fields
    }),
    getCustomFields() {
      return {
        ...this.contentData.custom_fields,
        ...this.contentData.export_custom_fields,
        ...this.contentData.bulk_custom_fields
      };
    },
    kilogramDif() {
      var num =
        ((this.contentData.net_kilograms - this.contentData.origin_kilograms) / this.contentData.origin_kilograms) *
        100;
      return num.toFixed(2);
    },
    autoNumber() {
      return this.contentData.pallet_number === "" || this.contentData.pallet_number === null;
    },
    calculateExport() {
      if (this.contentData.container.value != undefined) {
        const num = parseFloat(this.contentData.container.value.net_weight) * this.contentData.quantity || 0;
        return this.contentData.interplanta ? num : this.contentData.net_kilograms;
      } else {
        return 0;
      }
    },
    calculateGross() {
      if (this.connected && !this.contentData.id) {
        return this.socketWeight;
      } else {
        return this.contentData.gross_kilograms;
      }
    },
    calculateNet() {
      if (this.contentData.interplanta) {
        const num = parseFloat(this.calculateExport);
        this.contentData.gross_kilograms = this.calculateExport.toFixed(2);
        return isNaN(num) ? "..." : parseFloat(num).toFixed(2);
      } else {
        if (this.contentData.container.value != undefined) {
          const tara = parseFloat(this.contentData.container.value.material_weight) * this.contentData.quantity || 0;
          var num = 0;
          if (this.connected && !this.contentData.id) {
            if (this.selectedTypeWeightPallet == 1) {
              num = (this.socketWeight - this.contentData.pallet_type - tara).toFixed(2);
            }
            if (this.selectedTypeWeightPallet == 2 && this.contentData.manual_weight != undefined) {
              num = (this.socketWeight - this.contentData.manual_weight - tara).toFixed(2);
            }
          } else {
            if (this.selectedTypeWeightPallet == 1) {
              num = (this.contentData.gross_kilograms - this.contentData.pallet_type - tara).toFixed(2);
            }

            if (this.selectedTypeWeightPallet == 2 && this.contentData.manual_weight != undefined) {
              num = (this.contentData.gross_kilograms - this.contentData.manual_weight - tara).toFixed(2);
            }
          }
        }

        return isNaN(num) ? "..." : parseFloat(num).toFixed(2);
      }

      // return this.contentData.net_kilograms
    },
    modalSize() {
      return this.interplanta ? "lg" : "md";
    },
    // urlSearchContainer: function () {
    //   return "supplies/container/search_container_production/";
    // },
    urlSearchContainer: function () {
      // if (product == null) {
      // } else {
      //   const url = exportable ? "std" : "bulk";
      //   this.$axios
      //     .get("/api/v1/container/" + product + "/" + url + "/")
      //     .then((res) => {
      //       this.productSet.containers = res.data;
      //     })
      //     .catch((error) => console.log(error.menssaje));
      // }

      const url = this.contentData.product_type.exportable ? "std_search" : "bulk_search";

      return "/api/v1/container/" + this.contentData.product + "/" + url + "/";
    }
  },
  watch: {
    existing_pallet: {
      handler(val) {
        this.getWaybillPallets(this.waybillID);
      }
    },
    "contentData.product_type": {
      handler(val) {
        this.getProductContainers(val.exportable, this.contentData.product);
      }
    },
    "contentData.manual_weight": {
      handler(val) {}
    }
  },
  created() {
    bus.$off("editContent");
    bus.$on("editContent", (data) => {
      const that = this;
      // alert(JSON.stringify(data));
      window.setTimeout(function () {
        that.contentData.container = "";
        that.contentData.container = {
          text: data.container.name,
          value: {
            id: data.container.id,
            name: data.container.name,
            net_weight: data.container.net_weight,
            bulk: data.container.bulk,
            gross_weight: data.container.gross_weight,
            material_weight: data.container.material_weight
          }
        };
        that.$refs.container_select.selected = {
          text: data.container.name,
          value: {
            id: data.container.id,
            name: data.container.name,
            net_weight: data.container.net_weight,
            bulk: data.container.bulk,
            gross_weight: data.container.gross_weight,
            material_weight: data.container.material_weight
          }
        };
      }, 1000);

      that.editing_modal = true;
      that.existing_pallet = true;
      that.getWaybillPallets(that.waybillID);
      that.contentData.product = data.product;
      that.contentData.id = data.id;
      that.contentData.lot = data.lot;

      // First select product to run the apis and fill the select inputs. Then continue filling the modal inputs.
      that.getProductSet(data.product);
      that.contentData.variety = data.variety;
      that.contentData.condition = data.condition;
      that.contentData.pallet = data.pallet;
      that.contentData.origin = data.origin;

      that.contentData.interplanta = /true/i.test(data.exportable);

      const specs = [];
      for (let key in data.specifications) {
        const spec = data.specifications[key].id;
        specs.push(spec);
      }
      that.contentData.specifications = specs;

      that.contentData.quantity = data.quantity;
      that.contentData.creation_date = data.creation_date;
      that.contentData.net_kilograms = data.net_kilograms;
      that.contentData.origin_kilograms = data.origin_kilograms;
      that.contentData.gross_kilograms = data.gross_kilograms;
      that.contentData.product_type = {
        id: data.product_type,
        text: data.product_type_name,
        exportable: /true/i.test(data.exportable)
      };
      // that.getProductContainers(data.container.bulk, data.product);

      // that.contentData.container ={'id': data.container.id, 'net_weight': data.container.net_weight};

      that.contentData.classification = data.classification;

      that.formModal.status = true;
      this.$nextTick(function () {
        that.contentData.plant = data.plant.id;
        this.$refs["plantSelect"].handleInput(data.plant.id);
        this.contentData.custom_fields = data.custom_fields;
      });
    });
    bus.$off("createContent");
    bus.$on("createContent", (data) => {
      this.resetDetailForm();

      this.getWaybillPallets(this.waybillID);
      this.contentData.product = data.product;
      this.contentData.lot = data.id;
      this.contentData.interplanta = /true/i.test(data.exportable);
      // First select product to run the apis and fill the select inputs. Then continue filling the modal inputs.
      this.getProductSet(data.product);
      this.contentData.variety = data.variety;
      this.contentData.condition = data.condition;
      this.contentData.origin = data.origin;
      this.contentData.gross_kilograms = "0.00";
      this.contentData.product_type = {
        id: data.product_type,
        text: data.product_type_name,
        exportable: /true/i.test(data.exportable)
      };
      this.formModal.status = true;
    });
  },
  methods: {
    ...mapActions("socketModule", [
      "socketEmitSendMessage",
      "namespaceSocketEmitSendMessage",
      "socketDisconnect",
      "socketConnect",
      "namespaceSocketConnect",
      "namespaceSocketDisconnect"
    ]),
    resetDetailForm() {
      this.contentData.id = null;
      this.contentData.origin = null;
      this.contentData.interplanta = false;
      this.contentData.product = null;
      this.contentData.shipment_type = null;
      this.contentData.variety = null;
      this.contentData.condition = null;
      this.contentData.creation_date = null;
      this.contentData.product_type = [
        {
          exportable: null
        }
      ];
      this.contentData.plant = null;
      this.contentData.pallet = null;
      this.contentData.process_date = null;
      this.contentData.container = "";
      this.contentData.specifications = [];
      this.contentData.quantity = null;
      this.contentData.gross_kilograms = 0.0;
      this.contentData.pallet_number = "";
      this.contentData.net_kilograms = null;
      this.contentData.origin_kilograms = null;
      this.contentData.other = [];
      this.productSet = {
        product_types: [],
        containers: [],
        varieties: [],
        spec_type: [],
        spec_type_bulk: [],
        bulk_custom_fields: {},
        export_custom_fields: {}
      };
      this.existing_pallet = false;
      this.contentData.classification = "";
    },

    // ******** Getting variables based on selections

    getProducts() {
      this.$axios
        .get("/production/get_products/")
        .then((res) => {
          // console.log(res)
          const data = res.data.data;
          const products = [];
          for (let key in data) {
            const product = data[key];
            products.push(product);
          }
          this.products = products;
        })
        .catch((error) => console.log(errors));
    },

    getPalletTypes() {
      this.$axios
        .get("/api/v1/pallettype/")
        .then((res) => {
          // console.log(res)
          const data = res.data;
          const pallet_types = [];
          for (let key in data) {
            const pallet_type = data[key];
            pallet_types.push(pallet_type);
          }
          this.pallet_types = pallet_types;
        })
        .catch((error) => console.log(errors));
    },

    getBulkSpecs(a) {
      this.$axios
        .get("/production/get_bulk_specs/" + a)
        .then((res) => {
          const data = res.data.spec_type;
          const specs = [];
          for (let key in data) {
            const spec = data[key];
            specs.push(spec);
          }
          this.productSet.spec_type_bulk = specs;
          // this.productSet.spec_type_bulk = res.data.spec_type;
        })
        .catch((error) => console.log(error));
    },

    getCompanyFacilities(a) {
      this.$axios
        .get("/production/get_company_facilities/" + a)
        .then((res) => {
          this.companyFacilities = res.data;
          this.contentData.origin = this.companyFacilities.origins[0].value;
          this.disabledFields.plants = false;
          this.disabledFields.origins = false;
        })
        .catch((error) => {
          this.disabledFields.plants = true;
        });
    },
    getProductContainers(exportable, product) {
      if (product == null) {
      } else {
        const url = exportable ? "std" : "bulk";
        this.$axios
          .get("/api/v1/container/" + product + "/" + url + "/")
          .then((res) => {
            this.productSet.containers = res.data;
          })
          .catch((error) => console.log(error.menssaje));
      }
    },

    getProductSet(a) {
      this.$axios
        .get("/production/get_product_set/" + a)
        .then((res) => {
          this.productSet.spec_type = res.data.spec_type;
          this.productSet.varieties = res.data.varieties;
          this.productSet.export_custom_fields = res.data.export_custom_fields;
          this.productSet.bulk_custom_fields = res.data.bulk_custom_fields;

          const items = [];
          for (let key in res.data.product_types) {
            if (res.data.product_types[key].waste == false) {
              items.push(res.data.product_types[key]);
            }
          }

          this.productSet.product_types = items;
        })
        .catch((error) => console.log(error));
    },
    changeTipoProducto(obj) {
      if (obj.exportable == true) {
        this.contentData.interplanta = true;
      } else {
        this.contentData.specifications = [];
        this.contentData.interplanta = false;
      }
    },

    // ********  End getting variables based on selections

    getWaybillPallets(a) {
      this.$axios
        .get("/production/get_waybill_pallets/" + a)
        .then((res) => {
          const data = res.data.data;
          const items = [];
          for (let key in data) {
            const item = data[key];
            items.push(item);
          }
          this.pallets = items;
        })
        .catch((error) => console.log(errors));
    },
    submit(evt) {
      this.$v.$touch();
      evt.preventDefault();
      if (this.$v.$invalid) {
        this.$emit("validate", false);
      } else {
        this.$emit("validate", true);
        if (this.contentData.id === null) {
          this.createContent();
        } else {
          this.updateContent(this.contentData.id);
        }
      }
    },
    async createContent() {
      const thisV = this;
      thisV.loading = true;
      var palletData = {};
      if (thisV.existing_pallet == false) {
        palletData = {
          number: thisV.contentData.pallet_number,
          type: thisV.contentData.shipment_type,
          auto_number: thisV.autoNumber,
          receipt_waybill: thisV.waybillID,
          client: thisV.$store.getters.user.ID_CLIENTE,
          tipo: 1,
          contents: [
            {
              quantity: Number(thisV.contentData.quantity),
              net_kilograms: Number(thisV.calculateNet),
              origin_kilograms: Number(thisV.contentData.origin_kilograms),
              gross_kilograms: Number(thisV.calculateGross),
              origin: thisV.contentData.origin,
              condition: thisV.contentData.condition,
              lot: thisV.contentData.lot,
              product_type: thisV.contentData.product_type.id,
              pallet: "",
              process_id: "",
              overweight_type: "0",
              creation_date: thisV.contentData.interplanta ? thisV.contentData.creation_date : thisV.waybillDATE,
              variety: thisV.contentData.variety,
              client_customer: thisV.client_customer,
              waybill: thisV.waybillID,
              container: thisV.contentData.container.value.id,
              plant: thisV.contentData.plant,
              specifications: thisV.contentData.specifications.filter(Boolean),
              classification: thisV.contentData.classification,
              custom_fields: thisV.getCustomFields
            }
          ]
        };
      } else {
        console.log("no, or aca");
        palletData = {
          number: thisV.contentData.pallet_number,
          type: thisV.contentData.shipment_type,
          auto_number: thisV.autoNumber,
          receipt_waybill: thisV.waybillID,
          client: thisV.$store.getters.user.ID_CLIENTE,
          tipo: 2,
          contents: [
            {
              quantity: Number(thisV.contentData.quantity),
              net_kilograms: Number(thisV.calculateNet),
              origin_kilograms: Number(thisV.contentData.origin_kilograms),
              gross_kilograms: Number(thisV.calculateGross),
              origin: thisV.contentData.origin,
              condition: thisV.contentData.condition,
              product_type: thisV.contentData.product_type.id,
              pallet: thisV.contentData.pallet,
              lot: thisV.contentData.lot,
              process_id: "",
              overweight_type: "0",
              creation_date: thisV.contentData.interplanta ? thisV.contentData.creation_date : thisV.waybillDATE,
              variety: thisV.contentData.variety,
              client_customer: thisV.client_customer,
              waybill: thisV.waybillID,
              container: thisV.contentData.container.value.id,
              plant: thisV.contentData.plant,
              specifications: thisV.contentData.specifications.filter(Boolean),
              classification: thisV.contentData.classification,
              custom_fields: thisV.getCustomFields
            }
          ]
        };
      }
      console.log(palletData);
      try {
        const res = await thisV.$axios({
          method: "POST",
          url: "/api/v1/content/create_process_content/",
          headers: {
            "Content-Type": "application/json"
          },
          data: palletData
        });
        thisV.loading = false;
        if (res.data.status == 1) {
          thisV.resetDetailForm();
          thisV.$emit("refreshContents", this.waybillID);
          thisV.$toast.success("Agregado con éxito", "");
        }

        if (res.data.status == 2) {
          thisV.$toast.error("Numero de pallet ingresado ya éxiste", "");
        }
        thisV.$refs.modalContenido.hide();
      } catch (error) {
        console.log(error);
        thisV.loading = false;
        thisV.$refs.modalContenido.hide();
        thisV.$toast.error("Ocurrió un error interno. Consulte al administrador.", "");
      }
    },
    updateContent(a) {
      const formData = {
        number: this.contentData.pallet_number,
        type: this.contentData.shipment_type,
        auto_number: this.autoNumber,
        receipt_waybill: this.waybillID,
        tipo: 0,
        contents: [
          {
            id: a,
            quantity: Number(this.contentData.quantity),
            net_kilograms: Number(this.calculateNet),
            origin_kilograms: Number(this.contentData.origin_kilograms),
            gross_kilograms: Number(this.calculateGross),
            origin: this.contentData.origin,
            condition: this.contentData.condition,
            product_type: this.contentData.product_type.id,
            pallet: this.contentData.pallet,
            lot: this.contentData.lot,
            process_id: "",
            creation_date: this.contentData.interplanta ? this.contentData.creation_date : this.waybillDATE,
            variety: this.contentData.variety,
            client_customer: this.client_customer,
            waybill: this.waybillID,
            overweight_type: "0",
            container: this.contentData.container.value.id,
            plant: this.contentData.plant,
            specifications: this.contentData.specifications.filter(Boolean),
            classification: this.contentData.classification,
            custom_fields: this.getCustomFields
          }
        ]
      };
      this.formModal.status = false;
      this.editing_modal = false;
      this.loading = true;
      this.$axios
        .put("/api/v1/content/update_process_content/", formData)
        .then((res) => {
          this.loading = false;
          this.resetDetailForm();
          this.$emit("refreshContents", this.waybillID);
          miniToastr.success("Operación realizada con éxito", "");
        })
        .catch((error) => console.log(error));
    },
    handleBlur(evt) {
      this.getBulkSpecs(evt.value.id);
      //alert(JSON.stringify(evt.value.id));
    },
    toggle() {
      this.contentData.net_kilograms = this.calculateExport;
      this.contentData.interplanta = !this.interplanta;
    },
    inputSoloNumeroDecimal(event) {
      event.target.value = event.target.value.replace(/[^0-9.]/, "");
    }
  },
  beforeMount() {
    this.getProducts();
  }
};
</script>
